import type { FC } from 'react'
import { Box, Tooltip } from '@mui/material'
import WarningAmberOutlined from '@mui/icons-material/WarningAmberOutlined'
import type { SxProps, Theme } from '@mui/material'
import { standardTooltipProps } from '@/common/components'
import { useSessionStatus } from '@/features/status/hooks/useSessionStatus'
import type { ClaudeSession } from '@/features/events/conversation/state/types'
import { AgentModeSessionIcon } from '@/features/events/pages/events/components'
import { SessionStatus } from '@/infra/sse/status'

interface ConnectedSessionIconProps {
  readonly session: ClaudeSession
}

export const ConnectedSessionIcon: FC<ConnectedSessionIconProps> = ({ session }) => {
  const status = useSessionStatus(session.sessionId)

  if (status === SessionStatus.CORRUPTED) {
    return (
      <Tooltip {...standardTooltipProps} title="Corrupted session">
        <Box sx={corruptedWrapperSx} tabIndex={0} role="img" aria-label="Corrupted session">
          <AgentModeSessionIcon session={session} />
          <WarningAmberOutlined sx={warningIconSx} aria-hidden />
        </Box>
      </Tooltip>
    )
  }

  return <AgentModeSessionIcon session={session} />
}

const corruptedWrapperSx: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: 0.25,
}

const warningIconSx: SxProps<Theme> = {
  fontSize: '0.75rem',
  color: 'warning.main',
  opacity: 0.7,
}
